import { useTranslation } from 'react-i18next';
import { useSite } from '@salesforce/storefront-next-runtime/site-context';
import { useConfig } from '@salesforce/storefront-next-runtime/config';

/**
 * Returns the current site and locale identifiers for URL building.
 * Applies alias mappings when configured, falling back to the raw IDs.
 */
export function useCurrentSiteAndLocaleRef() {
    const { site } = useSite();
    const { i18n } = useTranslation();
    const config = useConfig();

    return {
        siteRef: site.alias ?? site.id,
        localeRef: config.localeAliasMap?.[i18n.language] ?? i18n.language,
    };
}
